module.exports = __webpack_public_path__ + "img/17.648d436d.png";